import React from 'react';
import '../styles/Button.css';
import PDF from '../helpers/PDF';

function AdminArticle(props) {
  const fname = props.data?.userId?.fname.charAt(0).toUpperCase() + props.data.userId?.fname.slice(1);
  const lname = props.data?.userId?.lname.charAt(0).toUpperCase() + props.data.userId?.lname.slice(1);
  return (
    <div className="container">
      <div className="columns">
        <div className="column is-2">
          <figure className="image is-4by5">
            <img className='has-ratio p-1' src={props.data.photo} alt='' />
          </figure>
        </div>
        <div className="column is-8 is-flex is-flex-direction-column is-justify-content-space-between">
          <p className='title is-size-4-mobile is-3 has-text-centered'>{props.data.topic}</p>
          <div className='is-flex is-justify-content-right'>
            <p className='ml-2 is-size-5 mr-2 '>Created By</p>
            <figure className="image is-32x32">
              <img className='is-rounded pic' src={props.data.userId?.image} alt='' />
            </figure>
            <p className='ml-2 is-size-5'>{fname} {lname}</p>
          </div>
        </div>
        <div className="column is-2 is-flex is-flex-direction-column is-justify-content-center is-align-items-center" style={{ borderLeft: "1px solid #7BC8FF" }}>
          <button className="button m-2 btn" style={{ width: '100px' }} onClick={() => { props.handlePopup(props.data) }} >
            <span className="icon is-small">
              <i className="fab fa-readme"></i>
            </span>
            <span>Read</span>
          </button>
          <button className="button m-2 btn" style={{ width: '100px' }} onClick={() => { PDF(props.data) }}>
            <span className="icon is-small">
              <i className="fas fa-print"></i>
            </span>
            <span>Print</span>
          </button>
          <button className="button m-2 del-btn" style={{ width: '100px' }} onClick={() => { props.handleDeleteArticle(props.data?._id) }}>
            <span className="icon is-small">
              <i className="fas fa-trash-alt"></i>
            </span>
            <span>Delete</span>
          </button>
        </div>
      </div>
    </div>
  )
}

export default AdminArticle;